"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatevErrorEnum = void 0;
var DatevErrorEnum;
(function (DatevErrorEnum) {
    // this usually means that they connected an account elsewhere
    // Rieken gives us the error message "Application Secret not found"
    DatevErrorEnum["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    // Usually a 403 error from Rieken
    DatevErrorEnum["FORBIDDEN"] = "FORBIDDEN";
    // this usually means that the account month is not set up in the customer's DUO account
    // Rieken gives us the error message "#DCO01002 - InvalidDxsoImportTargetFault"
    DatevErrorEnum["MISSING_ACCOUNT_MONTH"] = "MISSING_ACCOUNT_MONTH";
    DatevErrorEnum["UNSUPPORTED_FILE_TYPE"] = "UNSUPPORTED_FILE_TYPE";
    DatevErrorEnum["UNKNOWN"] = "UNKNOWN";
    DatevErrorEnum["DAMAGED_INVOICE"] = "DAMAGED_INVOICE";
    DatevErrorEnum["TIMEOUT"] = "TIMEOUT";
    DatevErrorEnum["INVALID_DATEV_ACCESS_TOKEN"] = "INVALID_DATEV_ACCESS_TOKEN";
    DatevErrorEnum["DATEV_SERVICE_UNAVAILABLE"] = "DATEV_SERVICE_UNAVAILABLE";
    DatevErrorEnum["SETUP_ABORT"] = "SETUP_ABORT";
})(DatevErrorEnum || (exports.DatevErrorEnum = DatevErrorEnum = {}));
